<template>
    <div class="text-center">
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="400"
            bottom left
            origin="top right"
            transition="scale-transition"
            offset-y>

            <template v-slot:activator="{ attrs, on }">
                <v-btn raised elevation="1" class="mt-1" min-width="0" text v-bind="attrs" v-on="on" @dblclick="onDblClick_Refresh">
                    <v-icon>mdi-calendar-search</v-icon>
                </v-btn>
            </template>
            <v-card>
                <v-card-title class="headline">
                    <p class="pl-7 mb-8 mt-8">
                        Search People
                    </p>
                </v-card-title>

                <v-form>
                    <!-- >>> Form, Fields -->
                    <v-list>
                        <v-list-item>
                            <v-combobox
                                v-model="bases"
                                :items="get_Bases"
                                item-text="aptCode"
                                item-value="idAirport"
                                label="Select one/more Base(s)"
                                prepend-icon="mdi-home"
                                clearable
                                multiple
                                small-chips>
                            </v-combobox>
                        </v-list-item>

                        <v-list-item>
                            <v-combobox
                                v-model="positions"
                                :items="positionItems"
                                label="Select one/more Position(s)"
                                prepend-icon="mdi-account-multiple-plus"
                                clearable
                                multiple
                                small-chips>
                            </v-combobox>
                        </v-list-item>

                        <v-list-item>
                            <v-combobox
                                v-model="funzioni"
                                :items="funzioniItems"
                                label="Select one/more Function(s)"
                                prepend-icon="mdi-account-details"
                                clearable
                                multiple
                                small-chips>
                            </v-combobox>
                        </v-list-item>

                        <v-list-item>
                            <v-combobox
                                v-model="departments"
                                :items="departmentItems"
                                label="Select one/more Department(s)"
                                prepend-icon="mdi-account-details"
                                clearable
                                multiple
                                small-chips>
                            </v-combobox>
                        </v-list-item>

                        <v-list-item>
                            <v-combobox
                                v-model="status"
                                :items="statusItems"
                                label="Select one/more Status"
                                prepend-icon="mdi-account-details"
                                clearable
                                multiple
                                small-chips>
                            </v-combobox>
                        </v-list-item>
                    </v-list>
                    <!-- <<< Form, Fields -->



                    <!-- >>> Action Buttons -->
                    <v-card-actions style="padding-bottom:10px;">
                        <v-spacer></v-spacer>
                        <v-btn style="width:120px; font-size:16px;" depressed elevation="1" outlined color="#ab3b7a" @click="menu = false"> Cancel</v-btn>
                        <v-btn style="width:120px; font-size:16px;" depressed elevation="1" color="primary" @click="onValidate"> Search</v-btn>
                    </v-card-actions>
                    <!-- <<< Action Buttons -->
                </v-form>
            </v-card>
        </v-menu>
    </div>
</template>


<script>
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';


    export default {
		name: 'PeopleFilterMenue',

		/* >>> *************************************************************** / /* Data */
		data: function() {

			return {
				menu: false,
                bases: null,
                positions: null,
                positionItems: [
                    'CP',
                    'FO',
                    'SCCM',
                    'CA',
                ],
                funzioni: null,
                funzioniItems: [
                    'TRE-LR',
                    'TRE-L',
                    'TRE-LR',
                    'TRI-L',
                    'LCC-LR',
                    'LCC-L',
                    'LTC-LR',
                    'LTC-L',
                    'CPT-LR',
                    'CPT-L',
                    'CPTt-L',
                    'FO-R',
                    'FOt-R',
                    'CCS',
                    'CFS',
                    'INSTR',
                    'X3',
                ],
                departments: [
                    'Cabin',
                    'Cockpit'
                ],
                departmentItems: [
                    'Cabin',
                    'Cockpit'
                ],
                status: ['Active'],
                statusItems: [
                    'Active',
                    'Inactive'
                ]
			};

		}, // eo funtion data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_Bases'
			]),

		}, // eo computed{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
				'actn_set_filterResources_searchTerm',
                'actn_call_getResourcesOfDepartment',
			]),


            /******************************************************************* 'Forms Validations'
            * Forms Validations:
            *******************************************************************/
            /*******************************************************************
            * onValidate()
            *
            * Desc: Check if Form is valid. Then From/To Checks. If so ... Call.
            * Note: Mapping bases because bases comes as array oj objects, and
            * Note: we only need idAirport of each object.
            *
            */
            onValidate: function() {

                let me = this,
                    searchTerms = null,
                    mappedBases = [];


                me.$toc('>>> views/people/components/core/FilterMenue.vue >>> onValidate');
                this.menu = false;

                if(this.bases !== null) {
                    mappedBases = this.bases.map((base) => base.idAirport);
                }

                searchTerms = {
                    bases: mappedBases !== null ? mappedBases : [],
                    funzioni: this.funzioni !== null ? this.funzioni : [],
                    departments: this.departments !== null ? this.departments : [],
                    positions: this.positions !== null ? this.positions : [],
                    status: this.status !== null ? this.status : [],
                };

                this.actn_set_filterResources_searchTerm(searchTerms);

            }, // eof onValidate()



            /*******************************************************************
            * onRefresh()
            *
            * Desc: Check if Form is valid. Then From/To Checks. If so ... Call.
            * Note: Mapping bases because bases comes as array oj objects, and
            * Note: we only need idAirport of each object.
            *
            */
            onDblClick_Refresh: function() {

                let me = this;


                me.$toc('>>> views/people/components/core/FilterMenue.vue >>> onDblClick_Refresh');
                this.menu = false;

                this.actn_call_getResourcesOfDepartment({ department: '12', secondLoad: false });
                this.actn_call_getResourcesOfDepartment({ department: '11', secondLoad: true });

            }, // eof onDblClick_Refresh()

        } // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style>
    .v-select.v-select--chips.v-select--chips--small .v-select__selections {
        min-height: 0px !important; /* 26px */
    }

    .v-label {
        font-size: 14px !important; /* 16px */

    }

    .v-select.v-select--chips input {
        min-height: 42px;
    }

    .v-btn__content {
        font-size: 12px;
    }


    .v-card {
        margin-top: 0px;
        margin-bottom: 0px;
    }
</style>
